import { useCallback, useEffect } from 'react'
import { useMaasAccount } from '@maas-tools/accounts'
import { useMaasKeycloak } from '@maas-tools/keycloak'
import { KEYCLOAK_REDIRECT_URL_LOGOUT } from 'core/common/constants/env'

const AppToken = props => {
  const { logoutKeycloakOnRefreshError = false, children } = props
  const { keycloak } = useMaasKeycloak()
  const { currentSeller } = useMaasAccount()

  const isDifferentTenant = useCallback(() => {
    return localStorage.getItem('tenant') !== currentSeller?.tenantId
  }, [currentSeller])

  useEffect(() => {
    keycloak.onAuthRefreshSuccess = () => {
      localStorage.setItem('token', keycloak.token)
    }

    localStorage.setItem('token', keycloak.token)
  }, [keycloak])

  useEffect(() => {
    if (logoutKeycloakOnRefreshError) {
      keycloak.onAuthRefreshError = () => {
        window.location.href = KEYCLOAK_REDIRECT_URL_LOGOUT
      }
    }
  }, [keycloak, logoutKeycloakOnRefreshError])

  useEffect(() => {
    localStorage.setItem('id', currentSeller?.id ?? '')

    if (isDifferentTenant()) {
      localStorage.setItem('tenant', currentSeller?.tenantId ?? '')
    }
  }, [currentSeller, isDifferentTenant])

  return children
}

export default AppToken
